/* esm.sh - @smithy/core@3.24.3/protocols */
export * from "/*@smithy/core@3.24.3/esnext/protocols.mjs";
